import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getTask } from '../../services';
import { Urls } from '../../config/urls';

export interface CountryAvailabilityDays {
  country: string;
  creditCard: number;
  debitCard: number;
  bankTransfer: number;
  cash: number;
}

interface AvailabilityDaysResponse {
  region: string | null;
  countries: CountryAvailabilityDays[];
}

interface UseAvailabilityDaysResult {
  data: CountryAvailabilityDays[] | null;
  loading: boolean;
  error: boolean;
}

export function useAvailabilityDays(region: string): UseAvailabilityDaysResult {
  const [data, setData] = useState<CountryAvailabilityDays[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { auth } = useSelector((state: any) => state);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(false);

      const { response, error: fetchError } = await getTask({
        url: `${Urls.api.availabilityDays}?region=${region}`,
        token: auth.token,
      });

      if (response) {
        setData((response as AvailabilityDaysResponse).countries);
      } else {
        setError(true);
      }
      setLoading(false);
    };

    if (auth.token) {
      fetchData();
    }
  }, [region, auth.token]);

  return { data, loading, error };
}
